import React from 'react';
import { motion } from 'framer-motion';
import { trackPixel } from '../lib/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const handleClick = () => {
    trackPixel('InitiateCheckout');
    onClick?.();
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-brand-orange text-white font-medium rounded-full 
        px-8 py-4 shadow-[0_8px_20px_rgba(224,123,57,0.3)]
        hover:shadow-[0_12px_25px_rgba(224,123,57,0.4)]
        hover:bg-[#d66e2d] transition-colors duration-300
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-9">
      {children}
    </motion.button>;
}